import fetchData, { APIURL, getData, postData } from "../fetch";


/**
 * @typedef {{
 *  id: string
 *  vehicle_category_id: string
 *  category: string 
 *  amount: string
 *  unit: string
 *  includesFuel: boolean
 *  upCountry: boolean
 *  includesDriver: boolean
 *  isActive: number
 * }} VehicleRateObject
 */





/**
 * 
 * @param {VehicleRateObject} data 
 * @returns {Promise<{code: number, message: string, rate: VehicleRateObject}>}
 */
const createRate = data => postData({ url: `${APIURL}/vehicle-rates`, data })


/**
 * get rate details
 * @param {String} id 
 * @param {string[]} include
 * @returns {Promise<{code: number, message: string, rate: VehicleRateObject}>}
 */
const getRate = (id, include = []) => fetchData({ url: `${APIURL}/vehicle-rates/${id}`, data: { include: include.join(",") } })


/**
 * @param {VehicleRateObject} data 
 * @param {string} id
 * @returns {Promise<{code: number, message: string, rate: VehicleRateObject}>}
 */
const updateRate = (data, id) => postData({ url: `${APIURL}/vehicle-rates/${id}`, data })

/**
 * 
 * @param {boolean} getAll If to get the expanded list  
 * @returns {Promise<{code: number, message: string, rates: VehicleRateObject[]}>}
 */
const getRates = () => getData({ url: `${APIURL}/vehicle-rates?expanded=1` });



export {
    getRate,
    getRates,
    createRate,
    updateRate,
}